import React, { useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import { Eraser, Check } from "lucide-react";

interface SignatureCanvasProps {
  onSave: (signature: string) => void;
  onComplete: (signature: string) => void; // now receives the signature data
}

const SignatureCanvas: React.FC<SignatureCanvasProps> = ({
  onSave,
  onComplete,
}) => {
  const signaturePadRef = useRef<SignaturePad>(null);
  const [hasDrawn, setHasDrawn] = useState(false);

  const clearSignature = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
      setHasDrawn(false);
    }
  };

  const handleComplete = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const signatureData = signaturePadRef.current.toDataURL();
      // Optionally update state via onSave if you want to save the signature elsewhere.
      onSave(signatureData);
      // Immediately call onComplete with the signature data.
      onComplete(signatureData);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="border-2 border-gray-300 rounded-lg bg-white">
        <SignaturePad
          ref={signaturePadRef}
          onBegin={() => setHasDrawn(true)}
          canvasProps={{
            className: "w-full h-64",
          }}
        />
      </div>
      <div className="flex justify-between mt-4">
        <button
          onClick={clearSignature}
          className="flex items-center px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
        >
          <Eraser className="w-4 h-4 mr-2" />
          Borrar
        </button>
        <button
          onClick={handleComplete}
          disabled={!hasDrawn}
          className="flex items-center px-6 py-2 btn-primary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <Check className="w-4 h-4 mr-2" />
          Firmar y enviar
        </button>
      </div>
    </div>
  );
};

export default SignatureCanvas;
